import type {
  QuaddieSelection,
  RacingCompetitor,
} from "@/features/betslip/types";
import type { QuaddieToggleInput } from "@/features/betslip/builders/types";

export const buildQuaddieSelection = (
  input: QuaddieToggleInput,
): QuaddieSelection => {
  const {
    event,
    market,
    hub,
    outcomeId,
    quaddieSelections,
    quaddieType,
    originType,
    originId,
    competitors: competitorList,
  } = input;

  const competitors: Record<string, RacingCompetitor> = {};
  for (const competitor of competitorList) {
    competitors[competitor.id] = competitor;
  }

  const marketStartTime = market.scheduledStartTime?.toDate() ?? null;

  return {
    kind: "quaddie",
    outcomeId,
    eventId: event.id,
    marketId: market.id,
    eventName: event.eventName ?? "",
    marketName: market.name ?? "",
    sport: event.sport ?? "",
    startTime: marketStartTime ?? event.scheduledStartTime ?? new Date(),
    hub,
    marketType: "QUADDIE",
    odds: 0,
    isSP: false,
    isMultiable: false,
    independentPerEvent: false,
    filters: event.filters ?? [],
    blockPromotionsBets: false,
    hasPromotionalMarkets: false,
    hasLiveMarkets: false,
    originType: originType ?? "BETTING",
    originId,
    quaddieSelections,
    quaddieType,
    competitors,
    marketStatus: market.status,
    eventStatus: event.status,
    streamUri: undefined,
    eventUrl: undefined,
    expectedResults: event.expectedResults,
    meetingId: event.meetingId,
  };
};
